"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const styles_1 = require("@mui/material/styles");
/**
 * * When showing --> expand first and then fade in
 * * When hiding --> fade out and then collapse
 */
const CollapseAndFade = ({ children, show, gradientFadeOutColor, baselineDelay = 0, ...rest }) => {
    const theme = (0, styles_1.useTheme)();
    const delay = `${theme.transitions.duration.shorter}ms`;
    const baseDelay = `${baselineDelay}ms`;
    return ((0, jsx_runtime_1.jsx)(Collapse_1.default, { in: show, sx: [
            {
                transitionDelay: !show ? delay : baseDelay,
                position: "relative",
            },
            gradientFadeOutColor &&
                !show && {
                "&:after": {
                    content: '""',
                    position: "absolute",
                    zIndex: 1,
                    bottom: 0,
                    left: 0,
                    backgroundImage: `linear-gradient(to bottom, rgba(${gradientFadeOutColor},0), rgba(${gradientFadeOutColor}, 1) 90%)`,
                    width: "100%",
                    height: rest.collapsedSize,
                },
            },
        ], ...rest, children: (0, jsx_runtime_1.jsx)(Fade_1.default, { in: show || !!rest.collapsedSize, style: {
                transitionDelay: show ? delay : baseDelay,
            }, children: (0, jsx_runtime_1.jsx)("div", { children: children }) }) }));
};
exports.default = CollapseAndFade;
//# sourceMappingURL=index.js.map